var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-modal',_vm._b({ref:"modal",attrs:{"target":_vm.target,"backdrop-styles":_vm.$options.backdropStyles}},'v-modal',_vm.$attrs,false),[_c('div',{staticClass:"app-modal"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }